import React from 'react';

import styled from '@emotion/styled';
import Button, { ButtonProps } from '@mui/material/Button';

import useWidth from '../../hooks/useWidth';

import './DupontButton.scss';

export interface DupontButtonProps extends ButtonProps {
  className?: string;
  type?: any;
  color?: any;
}

const StyledButton = styled(Button)((props: DupontButtonProps) => {
  props.size = useWidth();
  const backgroundColor = props.variant === 'outlined' ? '#fff' : 'main.primary';
  return {
    margin: '0 !important',
    borderRadius: '20px',
    paddingTop: '10px',
    paddingBottom: '7px',
    color: 'var(--du-color-grey-pale)',
    textTransform: 'none' as const,
    backgroundColor,
    ':hover': {
      backgroundColor,
      fontFamily: 'Diodrum-Semibold',
    },
  };
});

const DupontButton: React.FC<DupontButtonProps> = (props: DupontButtonProps) => {
  const getBtnClass = (type = '', color = 'primary') => {
    let btnClass = `${props.className || ''} dupont-btn__${type}`;
    if (color) {
      btnClass = `${btnClass}--${color}`;
    }
    return btnClass;
  };

  return (
    <StyledButton {...props} disableElevation className={`dupont-btn ${getBtnClass(props.type, props.color)}`}>
      {props.children}
    </StyledButton>
  );
};

export default DupontButton;
